import { MARQUEE_WORDS } from "@/data/profile";

export const Marquee = () => {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div data-testid="marquee-strip" className="border-y hairline overflow-hidden py-6 md:py-8 bg-[var(--surface)]">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="flex items-center whitespace-nowrap font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-none">
            <span className={i % 2 === 0 ? "outline-text" : "text-[var(--text)]"}>{w}</span>
            <span className="mx-8 md:mx-12 text-[var(--accent)] text-3xl md:text-5xl">—</span>
          </span>
        ))}
      </div>
    </div>
  );
};
